import { useLogto } from '@logto/react';
import React, { useEffect } from 'react';
import FullscreenLoading from '../FullscreenLoading';
import { getCurrentUrl } from '../../utils/string';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setUserRoles } from '../../store/tab/tabSlice';
import APMHandler from '../APMHandler';

interface AuthGateProps {
	redirPage: string;
	children: React.ReactNode;
}

const AuthGate: React.FC<AuthGateProps> = ({ children, redirPage }) => {
	const { isAuthenticated, signIn } = useLogto();
	const dispatch = useAppDispatch();

	// a user is only assigned their ID if the login process has completed
	const userId = useAppSelector((state) => state.user.id);

	// don't bother authing if running tests
	useEffect(() => {
		if (!isAuthenticated && process.env.NODE_ENV !== 'test') {
			localStorage.setItem('redirPage', redirPage);
			signIn(`${getCurrentUrl()}/callback`);
		} else if (process.env.NODE_ENV === 'test') {
			dispatch(setUserRoles({ roles: ['SUPERUSER', 'DEVELOPER', 'MSHT'] }));
		}
	}, []);

	return (isAuthenticated && userId) || process.env.NODE_ENV === 'test' ? (
		<APMHandler>{children}</APMHandler>
	) : (
		<FullscreenLoading redirPage={redirPage} />
	);
};

export default AuthGate;
